<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div *ngIf="seccion === 'L'">
    <div class="grid" *ngIf="cuePregunta.codigoTipoPregunta !== 'TEXTO' && cuePregunta.codigoTipoPregunta !== 'TIPOFE'">
      <div class="col-12 md:col-6 lg:col-6">
        <button type="button" pButton icon="fa fa-plus" (click)="nuevaRespuesta()"
                label="{{ 'BTN_AGREGAR' | translate}}"></button>
      </div>
    </div>
    <div class="grid" *ngIf="cuePregunta.codigoTipoPregunta !== 'TEXTO' && cuePregunta.codigoTipoPregunta !== 'TIPOFE'">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas"
                 [value]="cuePregunta.respuestas" selectionMode="single" dataKey="idCuestionarioPreguntaRespuesta"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-index="rowIndex">
            <tr [pSelectableRow]="row">
              <td>{{row.respuesta}}</td>
              <td>{{row.preguntaDepende}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorCorrecta" binary="true" disabled="true"></p-checkbox>
              </td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorJustificacion" binary="true" disabled="true"></p-checkbox>
              </td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                          title="{{'BTN_EDITAR' | translate}}" pButton
                          (click)="actualizar(row)"></button>
                  <button type="button" class="p-button btn" icon="fa fa-trash" data-toggle="tooltip"
                          title="{{'BTN_INHABILITAR' | translate}}" pButton
                          (click)="inhabilitar(row)"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fPregunta" name="fPregunta">
      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-6">
          <p-checkbox label="{{ 'CUESTIONARIOPREGUNTA.LBL_FILTRANTE' | translate}}" binary="true"
                      id="idIndicadorDescartante"
                      name="nomIndicadorDescartante"
                      formControlName="indicadorDescartante"></p-checkbox>
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <p-checkbox label="{{ 'CUESTIONARIOPREGUNTA.LBL_HABILITARPREGUNTA' | translate}}" binary="true"
                      id="idIndicadorHabilitar"
                      name="nomIndicadorHabilitar"
                      formControlName="indicadorHabilitado"></p-checkbox>
        </div>
      </div>
      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <div *ngIf="!guardando">
            <a (click)="regresar()" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
            <button icon="fa fa-plus" label="{{'BTN_GUARDAR' | translate }}"
                    type="submit"
                    pButton></button>
          </div>
          <div *ngIf="guardando">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_GUARDANDO' | translate }}</span>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div *ngIf="seccion === 'C' || seccion === 'E'">
    <form [formGroup]="forRespuesta" (ngSubmit)="guardarRespuesta()" novalidate id="fRespuesta" name="fRespuesta">
      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>{{ 'CUESTIONARIOPREGUNTA.LBL_PREGUNTA' | translate }}</label>
            <label class="falso-combo-texto">{{cuePregunta.pregunta}}</label>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>{{ 'CUESTIONARIOPREGUNTA.LBL_TIPO' | translate }}</label>
            <label class="falso-combo-texto">{{cuePregunta.tipoPregunta}}</label>
          </div>
        </div>
      </div>
      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{ 'CUESTIONARIOPREGUNTA.LBL_ASOCIARRESPUESTA' | translate }}</label>
            <div *ngIf="!resSeleccionada">
              <p-dropdown disableTab  id="idRespuesta" name="nomRespuesta" [options]="lisRespuesta"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                           formControlName="idRespuesta"
                          emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          optionValue="value"
                          optionLabel="label"
              ></p-dropdown>
              <div class="p-message p-messages-error p-corner-all" *ngIf="subRespuesta && f.idRespuesta.invalid">
                {{ 'CUESTIONARIOPREGUNTA.LBL_ASOCIARRESPUESTA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
            <div *ngIf="resSeleccionada && resSeleccionada.idCuestionarioPreguntaRespuesta">
              <label class="falso-combo-texto">{{resSeleccionada.respuesta}}</label>
            </div>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6" *ngIf="!cuestionario.indicadorAzar">
          <div class="div-form">
            <label>{{ 'CUESTIONARIOPREGUNTA.LBL_DEPENDENCIAPREGUNTA' | translate }}</label>
            <p-dropdown disableTab  id="idTipoCanal" name="nomTipoCanal" [options]="lisPreguntaDepende"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                         formControlName="idPreguntaDepende"
                        emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="subRespuesta && f.idPreguntaDepende.invalid">
              {{ 'CUESTIONARIOPREGUNTA.LBL_DEPENDENCIAPREGUNTA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-6">
          <p-checkbox label="{{ 'CUESTIONARIOPREGUNTA.LBL_CORRECTO' | translate}}" binary="true"
                      id="idCorrecto"
                      name="nomCorrecto"
                      formControlName="indicadorCorrecta"></p-checkbox>
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <p-checkbox label="{{ 'CUESTIONARIOPREGUNTA.LBL_JUSTIFICACION' | translate}}" binary="true"
                      id="idJustificacion"
                      name="nomJustificacion"
                      formControlName="indicadorJustificacion"></p-checkbox>
        </div>
      </div>
      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <div *ngIf="!guaRespuesta">
            <a (click)="regresarRespuesta(forRespuesta.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
            <button icon="fa fa-plus" label="{{'BTN_GUARDAR' | translate }}"
                    type="submit"
                    pButton></button>
          </div>
          <div *ngIf="guaRespuesta">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_GUARDANDO' | translate }}</span>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<p-confirmDialog #cd key="respuesta">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
